// 🆕 [Phase 56.3] Extrait de CalendrierProduction.jsx — dialog "Conflit de date détecté".
// Ouvert quand on tente de placer un BT à une date où un autre BT du même chef est déjà
// présent. Propose 2 stratégies : Incruster (décale les suivants) ou Interchanger (swap).
//
// Payload data : { bon, conflictingBon, newDates, updatedEquipements? }
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function DialogConflitChoice({ data, onClose, onIncruster, onInterchanger }) {
  if (!data) return null;
  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[550px] max-w-[95vw]">
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2 text-amber-600">
            <AlertTriangle className="w-5 h-5" />
            Conflit de date détecté
          </DialogTitle>
          <DialogDescription>
            Un autre bon de travail du même chef d'équipe ({data.bon.chef_equipe_nom}) occupe déjà cette période.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm">
            <p className="font-medium text-amber-800 mb-1">BT en conflit :</p>
            <p className="text-gray-700">
              {data.conflictingBon.client_nom_display || 'Client inconnu'}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Dossier #{data.conflictingBon.numero_dossier}
            </p>
          </div>

          <p className="text-sm font-medium text-gray-700">Que voulez-vous faire ?</p>

          <div className="space-y-2">
            <Button
              variant="outline"
              className="w-full justify-start text-left h-auto py-4 border-blue-300 hover:bg-blue-50"
              onClick={onIncruster}
            >
              <div className="flex items-start gap-3">
                <div className="mt-0.5 w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <div className="font-medium text-blue-700">Incruster</div>
                  <div className="text-xs text-gray-600 mt-0.5">
                    Placer ce BT ici et décaler automatiquement TOUS les BTs suivants du même chef
                  </div>
                </div>
              </div>
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start text-left h-auto py-4 border-purple-300 hover:bg-purple-50"
              onClick={onInterchanger}
            >
              <div className="flex items-start gap-3">
                <div className="mt-0.5 w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <div className="font-medium text-purple-700">Interchanger</div>
                  <div className="text-xs text-gray-600 mt-0.5">
                    Échanger la position des deux BTs (celui-ci prend la place du BT en conflit, et vice-versa)
                  </div>
                </div>
              </div>
            </Button>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DialogConflitChoice;
